<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>创作者列表</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card>
            <el-form ref="form" :model="searchForm" label-width="80px" :inline="true" size="small" class="admin_from">
                <el-form-item label="" :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':''">
                    <el-input v-model="searchForm.phone" placeholder="请输入手机号"
                    ></el-input>
                </el-form-item>
                <el-form-item label="" :class="this.$store.state.windowWidth<=this.$store.state.MaxWidth?'maxWidth':''">
                    <el-input v-model="searchForm.username" placeholder="请输入用户名"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="search">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table
                    size="small"
                    :data="tableData"
                    border
                    style="width: 100%">

                <el-table-column
                        prop="writer_id"
                        label="作者ID">
                </el-table-column>
                <el-table-column
                        prop="name"
                        label="真实姓名">
                </el-table-column>
                <el-table-column
                        prop="pen_name"
                        label="笔名">
                </el-table-column>
                <el-table-column
                        prop="mail"
                        label="邮箱">
                </el-table-column>
                <el-table-column
                        prop="phone"
                        label="手机号">
                </el-table-column>
                <el-table-column
                        prop="user.nickname"
                        label="用户昵称">
                </el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status==0">待审核</span>
                        <span v-if="scope.row.status==1">审核通过</span>
                        <span v-if="scope.row.status==2">审核失败</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="created_at"
                        label="创建时间">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="150px">
                    <template slot-scope="scope">
                        <el-button type="success" plain size="small" @click="pass(scope.row.writer_id)" v-if="scope.row.status!==1">通过</el-button>
                        <el-button type="danger" plain size="small" @click="refuse(scope.row.writer_id)">拒绝</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="el-pagination">
                <el-pagination
                        background
                        @size-change="changeSize"
                        @current-change="changeCurrent"
                        :current-page="params.pagenum"
                        :page-sizes="[10, 20, 30, 40]"
                        :page-size="params.pagesize"
                        :layout="this.$store.state.paginationLayout"
                        :total="params.totals">
                </el-pagination>
            </div>

        </el-card>
    </div>
</template>

<script>
  import {uploadimg} from '../../utils/common'
  import {formatDate} from '../../utils/common'

  export default {

    name: "User",
    data() {
      return {
        params: {
          pagenum: 1,
          pagesize: 10,
          totals: 0
        },
        tableData: [],
        searchForm: {
          phone: '',
          username: '',
          status: '',
          type: '',
        }
      }
    },
    created() {
      this.getList()
    },
    methods: {
      getList() {
        let data = {
          page: this.params.pagenum,
          page_size: this.params.pagesize,
          phone: this.searchForm.phone,
          username: this.searchForm.username,
          status: this.searchForm.status,
          type: this.searchForm.type,
        };
        this.$axios.post("admin/writer/index", data).then((res) => {
          this.params.totals = parseInt(res.data.count);
          this.tableData = res.data.list;
        });
      },
      // 每页显示多少条
      changeSize(val) {
        this.params.pagesize = val;
        this.getList()
      },
      // 当前显示的页数
      changeCurrent(val) {
        this.params.pagenum = val;
        this.getList()
      },
      pass(id) {
        let status = 1;
        this.communal(id,status)
      },
      refuse(id) {
        let status = 2;
        this.communal(id,status)
      },
      communal(id, status) {
        this.$confirm('确定要进行操作, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.post('/admin/writer/set_status', {id: id, status: status}).then((res) => {
            this.$message.success('操作成功!');
            this.getList();
          });
        })
      },
      search() {
        this.params.pagenum = 1;
        this.getList();
      },
    }
  }
</script>

<style scoped>
    .img {
        display: flex;
        align-items: center;
    }

    .img > img {
        margin-right: 10px;
    }
</style>